const EmployeeProfileRoutes = {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    meta: {
        requiresAuth: false
    },
    children: [
        {
            name: 'employee-profile',
            path: '/employee-profile',
            meta: {
                permissions: 'EmpInfo:update'
            },
            component: () => import('@/views/employee-profile/EmployeeProfile.vue')
        },
        {
            name: 'employee-profile-view',
            path: '/employee-profile/:mode/:empCode/:periodId',
            meta: {
                permissions: 'EmpInfo:update'
            },
            component: () => import('@/views/employee-profile/EmployeeProfile.vue')
        }
    ]
};

export default EmployeeProfileRoutes;
